// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { createContext, FunctionComponent, ReactNode } from 'react';

export type RootProps = {
  children: ReactNode;
};

type ToggleTheme = () => void;

export const ToggleThemeContext = createContext<ToggleTheme>(
  (): void => undefined,
);

export const Root: FunctionComponent<RootProps> = ({ children }) => {
  return children;
};
